import { CoinIcon } from 'components/BuildersCustomComponents/ReferFriendNoLimits/components/CoinIcon'

import classes from './styles.module.scss'

interface ReferFriendNoLimitsProps {
  text: string
}

export const ReferFriendNoLimits = ({ text }: ReferFriendNoLimitsProps) => {
  return (
    <div className={classes.root}>
      <div className={classes.iconWrapper}>
        <CoinIcon className={classes.icon} />
      </div>
      <div className={classes.text}>{text}</div>
    </div>
  )
}
